import React from 'react';
import { Icon, IconProps } from '@chakra-ui/icon';
import { ReactComponent as Back } from '@src/icons/arrow-back.svg';

export const BackIcon: React.FC<IconProps> = (props) => (
  <Icon viewBox="0 0 24 24" {...props} as={Back} />
);
